import { Link } from 'gatsby';
import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import { getSingleLocale } from '../../../../utils/utils';
import type { BackLinkProps } from './types';

const BackLink: FC<BackLinkProps> = ({ lang }) => {
    const homePage = () => `/${lang === 'en' ? '' : getSingleLocale(lang)}`;
    const { t } = useTranslation();

    return (
        <Link
            to={homePage()}
            className={`flex fixed bottom-10 left-3 bg-white md:top-32 
            md:left-10 w-10 h-10 text-gray-500 text-xl justify-center 
            items-center rounded-full border-transparent shadow-md 
            hover:border-2 hover:border-solid hover:border-gray-200`}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={t('general.go_home', 'Return to main page')}
            id="arrow_back"
        >
            <span className="leading-10">&larr;</span>
        </Link>
    );
};

export default BackLink;
